import { NgModule } from '@angular/core';
import { CalenderComponent } from '~shared/svgs/calender/calender.component';


@NgModule({
  declarations: [
    CalenderComponent
  ],
  exports: [
    CalenderComponent
  ]
})
export class CalenderModule {}
